import React from 'react'
import { GetServerSideProps } from 'next'
import Head from 'next/head'

import { API } from '../../../../revelry_api'
import FourOFour from '../../../../components/pages/FourOFour'
import { FuneralHome, LifePageNavItem, ObituarySnippet } from '../../../../types'
import { FuneralHomeFooter } from '../../../../components/FuneralHomeFooter'
import LifePageLayout from '../../../../components/LifePageLayout'
import Obituary from '../../../../components/models/Obituary'
import ObituaryMeta from '../../../../components/ObituaryMeta'
import PLP from '../../../../components/pages/flowerstore/PLP'
import { routes } from '../../../../routes'

interface Props {
  funeralHome: FuneralHome | null
  obituary: ObituarySnippet | null
}

const FlowerstorePage: React.FC<Props> = ({ funeralHome, obituary }) => {
  if (!funeralHome || !obituary) {
    return <FourOFour />
  }

  const pageTitle = `${Obituary.deceasedFullName(obituary)} Flowerstore - ${funeralHome.name}`
  const pageDescription = `Send flowers to express your condolences for ${Obituary.deceasedFullName(
    obituary,
  )}. Send flowers, upload memories & photos, and view funeral service information.`

  return (
    <>
      <ObituaryMeta
        obituary={obituary}
        funeralHome={funeralHome}
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        canonicalPath={routes.flowerstore(obituary)}
      />

      <Head>
        <meta name="robots" content="noindex" />
      </Head>

      <LifePageLayout activeNavItem={LifePageNavItem.FLOWERS} obituary={obituary}>
        <PLP obituary={obituary} />
      </LifePageLayout>

      <FuneralHomeFooter />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (req) => {
  try {
    const slugArray = (req.params.slug as string).split('-')
    const obituaryID = slugArray[slugArray.length - 1]
    const [funeralHome, obituary] = await Promise.all([
      API.funeralHomes.load(),
      API.obituaries.load(obituaryID),
    ])

    return { props: { funeralHome, obituary } }
  } catch (e) {
    return { props: { funeralHome: null, obituary: null } }
  }
}

export default FlowerstorePage
